var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateInbound = function SvgCreateInbound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_inbound_svg2__a",
    x1: 5.83,
    x2: 194.17,
    y1: 102.04,
    y2: 102.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_inbound_svg2__b",
    x1: -680.1,
    x2: -835.35,
    y1: -4899.13,
    y2: -5013.72,
    gradientTransform: "rotate(-135 710.686 -2611.167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096",
    stopOpacity: 0.25
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M172.57 146.02a2.9 2.9 0 0 0-3.16-.63c-1.09.45-1.79 1.5-1.79 2.68v5.19H64.07l-7.24-7.25a2.9 2.9 0 0 0-3.16-.63c-1.09.45-1.79 1.5-1.79 2.68v4.96a17.77 17.77 0 0 1-14.94-17.6c0-9.83 8-17.83 17.84-17.83h46.3l7.24 7.24c.82.82 2.1 1.08 3.16.63 1.09-.45 1.79-1.5 1.79-2.68v-5.19h31.95c26.99 0 48.94-21.95 48.94-48.93s-21.95-48.94-48.94-48.94h-12.91l-7.24-7.24a2.9 2.9 0 0 0-3.16-.63c-1.09.45-1.79 1.5-1.79 2.68v5.19H8.73c-1.6 0-2.9 1.3-2.9 2.9v25.3c0 1.6 1.3 2.9 2.9 2.9h111.38v5.19c0 1.18.7 2.23 1.79 2.68 1.06.44 2.35.18 3.16-.63l7.24-7.24h12.92c9.84 0 17.84 8 17.84 17.83s-8 17.83-17.84 17.83h-31.95v-5.2c0-1.18-.7-2.23-1.79-2.68s-2.33-.2-3.16.63l-7.25 7.25h-46.3c-26.99 0-48.94 21.95-48.94 48.94s20.14 47.34 46.04 48.85v5.28c0 1.18.7 2.23 1.79 2.68 1.07.45 2.35.19 3.17-.63l7.24-7.24h103.55v5.19c0 1.18.7 2.23 1.79 2.68.35.15.73.22 1.11.22.78 0 1.5-.3 2.05-.85l20.75-20.74c.55-.55.85-1.28.85-2.05s-.3-1.5-.85-2.05l-20.75-20.75Zm-2.05 32.54H69.88l7.69-7.69c.55-.55.85-1.28.85-2.05s-.3-1.5-.85-2.05l-7.69-7.69h100.64c1.6 0 2.91-1.3 2.91-2.9v-1.08l13.74 13.74-13.74 13.73v-1.08c0-1.6-1.3-2.9-2.91-2.9Zm-115.75 0c-23.78 0-43.13-19.35-43.13-43.13S30.99 92.3 54.77 92.3h40.49l-7.69 7.69a2.915 2.915 0 0 0 0 4.11l7.69 7.69H54.77c-13.04 0-23.65 10.61-23.65 23.64s10.61 23.64 23.65 23.64c1.6 0 2.9-1.3 2.9-2.9v-1.08l13.73 13.74-13.73 13.73v-1.08c0-1.6-1.3-2.9-2.9-2.9Zm55.6-86.26h34.86c13.04 0 23.65-10.61 23.65-23.64s-10.61-23.64-23.65-23.64h-7.11l7.69-7.69c.55-.55.85-1.28.85-2.05s-.3-1.51-.85-2.05l-7.69-7.69h7.11c23.78 0 43.13 19.35 43.13 43.13s-19.35 43.13-43.13 43.13h-34.86c-1.6 0-2.9 1.3-2.9 2.9v1.08l-13.73-13.73 13.73-13.73v1.09c0 1.6 1.3 2.9 2.9 2.9Zm12.65-47.28H11.64V25.53h111.38c1.6 0 2.9-1.3 2.9-2.9v-1.09l13.73 13.73L125.92 49v-1.09c0-1.6-1.3-2.9-2.9-2.9Z",
    style: {
      fill: "url(#create_inbound_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.12 1.49 94.93 94.93a5.06 5.06 0 0 1 0 7.16l-94.93 94.93c-3.19 3.19-8.64.93-8.64-3.58V5.07c0-4.51 5.45-6.77 8.64-3.58",
    style: {
      fill: "url(#create_inbound_svg2__b)",
      opacity: 0.25
    }
  }));
};
export default SvgCreateInbound;